export default "__VITE_ASSET__9hPCDZ$D__"